import { render } from "./DeltaView.vue?vue&type=template&id=aba85d62&scoped=true&ts=true"
import script from "./DeltaView.vue?vue&type=script&lang=ts"
export * from "./DeltaView.vue?vue&type=script&lang=ts"

import "./DeltaView.vue?vue&type=style&index=0&id=aba85d62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba85d62"]])

export default __exports__